module["exports"] = [
  "Sr.",
  "Sra.",
  "Sta."
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/es_MX/name/prefix.js
 ** module id = 508
 ** module chunks = 0
 **/